import { apiAuth, apiResponseType } from ".";

export const getDistributionsData = (page: number = 1): apiResponseType =>
  apiAuth.get(`distributions?page=${page}`);

export const registerDistributionsData = (data) =>
  apiAuth.post("/distributions/unities/store", data) as apiResponseType;

export const deleteDistributionsData = (uuid: string) =>
  apiAuth.delete(`distributions/${uuid}/destroy`) as apiResponseType;

export const updateDistributionsData = (uuid: string, data) =>
  apiAuth.put(`distributions/${uuid}/update`, data) as apiResponseType;

export const getShowDistributions = (uuid: string) =>
  apiAuth.get(`distributions/${uuid}/show`) as apiResponseType;

export const searchDistributionsData = (params: {
  name: string;
}): apiResponseType => apiAuth.get(`distributions?name=${params.name}`);

export const setStatusDistributions = (uuid: string) =>
  apiAuth.put(`distributions/${uuid}/toggle-status`) as apiResponseType;

export const getSellerBalances = (seller_id: string, page?: number, contest_id?: number) => {
  const params = new URLSearchParams();
  if (page) params.append("page", String(page));
  if (contest_id) params.append("contest_id", String(contest_id));
  const query = params.toString();
  return apiAuth.get(`/distributions/seller-balances/${seller_id}${query ? `?${query}` : ''}`) as apiResponseType;
};

export const getSellerContestsSummary = (seller_id: string) =>
  apiAuth.get(`/distributions/seller-balances/${seller_id}/contests-summary`) as apiResponseType;

export const storeDistributionsDataUnityBalances = (_, data) =>
  apiAuth.post("/distributions/unity-balances/store", data) as apiResponseType;

export const storeDistributionsDataUnityBalancesWithFiles = (_, data: FormData) =>
  apiAuth.post("/distributions/unity-balances/store", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }) as apiResponseType;

export const getDistributionsDataUnityBalances = (
  page: number = 1,
  unity_id?: string
): apiResponseType =>
  apiAuth.get(
    `distributions/unity-balances?page=${page}${
      unity_id ? `&unity_id=${unity_id}` : ""
    }`
  );

export const searchDistributionsDataUnityBalances = (params: {
  name: string;
}): apiResponseType =>
  apiAuth.get(`distributions/unity-balances?name=${params.name}`);

export const deleteDistributionsDataUnityBalances = (uuid: string) =>
  apiAuth.delete(
    `distributions/unity-balances/${uuid}/destroy`
  ) as apiResponseType;

export const updateDistributionsDataUnityBalances = (uuid: string, data) =>
  apiAuth.put(
    `distributions/unity-balances/${uuid}/update`,
    data
  ) as apiResponseType;

export const getShowDistributionsUnityBalances = (uuid: string) =>
  apiAuth.get(`distributions/unity-balances/${uuid}/show`) as apiResponseType;

export const setStatusDistributionsUnityBalances = (uuid: string) =>
  apiAuth.put(
    `distributions/unity-balances/${uuid}/toggle-status`
  ) as apiResponseType;

export const getDistributionsDataUnityBalancesByUnityId = (unity_id: string) =>
  apiAuth.get(
    `/distributions/unity-balances?unity_id=${unity_id}`
  ) as apiResponseType;

export const getDistributionSellerBalances = (contest_id: string) =>
  apiAuth.get(
    `/distributions/seller-balances/${contest_id}/show`
  ) as apiResponseType;

export const getDistributionsProcessBySellerId = (seller_id: string, status_id?: number) =>
  apiAuth.get(
    `/distribution-processes?seller_id=${seller_id}${status_id !== undefined ? `&status_id=${status_id}` : ''}&per_page=500`
  ) as apiResponseType;

export const getAllDistributionsProcessBySellerId = (seller_id: string) =>
  apiAuth.get(
    `/distribution-processes?seller_id=${seller_id}&per_page=500`
  ) as apiResponseType;

export const storeSellersProcessDistributionData = (data) =>
  apiAuth.post("/distribution-processes/store", data) as apiResponseType;

export const updateSellersProcessDistributionData = (uuid: string, data) =>
  apiAuth.put(
    `/distribution-processes/${uuid}/update`,
    data
  ) as apiResponseType;

export const approveSellersProcessDistributionData = (uuid: string) =>
  apiAuth.put(`/distribution-processes/${uuid}/approve`) as apiResponseType;

export const rejectSellersProcessDistributionData = (uuid: string) =>
  apiAuth.put(`/distribution-processes/${uuid}/reject`) as apiResponseType;

export const deleteSellersProcessDistributionData = (uuid: string) =>
  apiAuth.delete(`/distribution-processes/${uuid}/destroy`) as apiResponseType;

export const approveSellerDistribution = (uuid: string) =>
  apiAuth.put(
    `/distribution-processes/${uuid}/approve-seller-distribution`
  ) as apiResponseType;

export const rejectSellerDistribution = (uuid: string) =>
  apiAuth.put(
    `/distribution-processes/${uuid}/reject-seller-distribution`
  ) as apiResponseType;

export const acceptSellerDistribution = (uuid: string) =>
  apiAuth.put(
    `/distribution-processes/${uuid}/accept-seller-distribution`
  ) as apiResponseType;

export const acceptSellerDistributionBetweenUnities = (uuid: string) =>
  apiAuth.put(
    `/distribution-processes/${uuid}/accept-distribution-between-sellers`
  ) as apiResponseType;

export const rejectSellerDistributionBetweenUnities = (uuid: string) =>
  apiAuth.put(
    `/distribution-processes/${uuid}/reject-distribution-between-sellers`
  ) as apiResponseType;

/**
 * Busca as distribuições de saldo da unidade
 *
 * @function getUnityBalances
 * @param {string} unity_id - ID da unidade
 * @returns {apiResponseType} Resposta da API com distribuições da unidade
 */
export const getUnityBalances = (unity_id: string): apiResponseType =>
  apiAuth.get(`distributions/unity-balances/${unity_id}`);

/**
 * Distribui diretamente para vendedores
 *
 * @function distributeDirectlyToSellers
 * @param {object} data - Dados da distribuição
 * @param {number} data.unity_id - ID da unidade
 * @param {number} data.contest_id - ID do concurso
 * @param {number} data.contest_product_classification_id - ID da classificação do produto
 * @param {Array} data.sellers - Array com vendedores e quantidades
 * @returns {apiResponseType} Resposta da API
 */
export const distributeDirectlyToSellers = (data: {
  unity_id: number;
  contest_id: number;
  contest_product_classification_id: number;
  sellers: Array<{
    id: number;
    quota_quantity: number;
  }>;
}): apiResponseType =>
  apiAuth.post("distributions/seller-balances/distribute-directly", data);

export const showDistributionsData = (contest_uuid: string) =>
  apiAuth.get(
    `distributions/unity-balances/${contest_uuid}/show`
  ) as apiResponseType;

// Usado para user type de responsavel de unidades.

export const getDistributionUnitiesPerUnitResponsableSellers = (
  contest_id: string,
  contest_product_classification_id: string
) =>
  apiAuth.get(
    `/distributions/sellers/${contest_id}/quotas?contest_product_classification_id=${contest_product_classification_id}`
  ) as apiResponseType;

export const getDistributionsPerUnitResponsable = (unit_id: string) =>
  apiAuth.get(`/distributions/unities/${unit_id}`) as apiResponseType;

export const updateDistributionsSellers = (contest_id: string, data) =>
  apiAuth.put(
    `/distributions/sellers/${contest_id}/update`,
    data
  ) as apiResponseType;

export const updateDistributionsSellersWithFiles = (contest_id: string, data: FormData) =>
  apiAuth.put(
    `/distributions/sellers/${contest_id}/update`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ) as apiResponseType;

export const storeDistributionSellerBalances = (data: any) =>
  apiAuth.post("/distributions/seller-balances/store", data) as apiResponseType;

export const storeDistributionSellerBalancesWithFiles = (data: FormData) =>
  apiAuth.post("/distributions/seller-balances/store", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }) as apiResponseType;

export const getDistributionUnityBalances = (unity_id: string) =>
  apiAuth.get(
    `/distributions/unity-balances?unity_id=${unity_id}`
  ) as apiResponseType;

export const getDistributionUnityBalancesByContests = (unity_id: string) =>
  apiAuth.get(
    `/distributions/unity-balances/contest?unity_id=${unity_id}`
  ) as apiResponseType;

/**
 * Busca dados simplificados de distribuição com balanços por produto e unidade
 * @param {string} contest_id - ID do concurso
 * @param {number} page - Número da página (default: 1)
 * @param {number} per_page - Itens por página (default: 100)
 * @param {string} product_name - Filtro por nome do produto (opcional)
 * @returns {apiResponseType} Resposta da API com produtos e balanços das unidades paginados
 */
export const getDistributionSimplified = (contest_id: string, page: number = 1, per_page: number = 100, product_name?: string): apiResponseType => {
  const params = new URLSearchParams();
  params.append('page', page.toString());
  params.append('per_page', per_page.toString());
  if (product_name) {
    params.append('product_name', product_name);
  }
  return apiAuth.get(`/distributions/unity-balances/show/${contest_id}?${params.toString()}`);
};

/**
 * Busca dados simplificados de distribuição com balanços por produto e vendedor
 * @param {string} contest_id - ID do concurso
 * @param {number} page - Número da página (default: 1)
 * @param {number} per_page - Itens por página (default: 100)
 * @param {string} product_name - Filtro por nome do produto (opcional)
 * @returns {apiResponseType} Resposta da API com produtos e balanços dos vendedores
 */
export const getSellerBalancesSimplified = (
  contest_id: string,
  page?: number,
  per_page?: number,
  product_name?: string
): apiResponseType => {
  const params = new URLSearchParams();
  if (page) params.append('page', page.toString());
  if (per_page) params.append('per_page', per_page.toString());
  if (product_name) params.append('product_name', product_name);
  const queryString = params.toString();
  return apiAuth.get(`/distributions/seller-balances/show/${contest_id}${queryString ? `?${queryString}` : ''}`);
};

/**
 * Busca detalhes das distribuições por contest_product_classification_id
 * @param {string} contest_id - ID do concurso
 * @param {number} cp_classification_id - ID da classificação do produto
 * @returns {apiResponseType} Resposta da API com detalhes das distribuições
 */
export const getDistributionDetails = (contest_id: string, cp_classification_id: number): apiResponseType =>
  apiAuth.get(`/distributions/seller-balances/show/${contest_id}/details?cp_classification_id=${cp_classification_id}`);

export const getUnityDistributionDetails = (contest_id: string, cp_classification_id: number): apiResponseType =>
  apiAuth.get(`/distributions/unity-balances/show/${contest_id}/details?cp_classification_id=${cp_classification_id}`);

/**
 * Busca todo o caminho/histórico de distribuições de um produto
 * Inclui todos os tipos: Admin->Unidade, Unidade->Vendedor, Entre Unidades, Entre Vendedores, Vendedor->Unidade
 * @param {string} contest_id - ID do concurso
 * @param {number} cp_classification_id - ID da classificação do produto
 * @returns {apiResponseType} Resposta da API com histórico completo das distribuições
 */
export const getFullDistributionPath = (contest_id: string, cp_classification_id: number): apiResponseType =>
  apiAuth.get(`/distributions/unity-balances/show/${contest_id}/full-path?cp_classification_id=${cp_classification_id}`);

/**
 * Busca dados simplificados de distribuição entre vendedores
 * @param {string} contest_id - ID do concurso
 * @param {number} page - Número da página
 * @param {number} per_page - Itens por página
 * @param {string} product_name - Filtro por nome do produto (opcional)
 * @returns {apiResponseType} Resposta da API com balanços dos vendedores para distribuição entre vendedores
 */
export const getSellerToSellerBalancesSimplified = (
  contest_id: string,
  page?: number,
  per_page?: number,
  product_name?: string
): apiResponseType => {
  const params = new URLSearchParams();
  if (page) params.append('page', page.toString());
  if (per_page) params.append('per_page', per_page.toString());
  if (product_name) params.append('product_name', product_name);
  const queryString = params.toString();
  return apiAuth.get(`/distributions/seller-balances/between/show/${contest_id}${queryString ? `?${queryString}` : ''}`);
};

/**
 * Busca dados simplificados de distribuição de vendedor para unidade
 * @param {string} contest_id - ID do concurso
 * @param {number} page - Número da página
 * @param {number} per_page - Itens por página
 * @param {string} product_name - Filtro por nome do produto (opcional)
 * @returns {apiResponseType} Resposta da API com balanços dos vendedores para distribuição para unidade
 */
export const getSellerToUnityBalancesSimplified = (
  contest_id: string,
  page?: number,
  per_page?: number,
  product_name?: string
): apiResponseType => {
  const params = new URLSearchParams();
  if (page) params.append('page', page.toString());
  if (per_page) params.append('per_page', per_page.toString());
  if (product_name) params.append('product_name', product_name);
  const queryString = params.toString();
  return apiAuth.get(`/distributions/seller-balances/seller-unity/show/${contest_id}${queryString ? `?${queryString}` : ''}`);
};

/**
 * Busca detalhes das distribuições de vendedor para unidade por contest_product_classification_id
 * @param {string} contest_id - ID do concurso
 * @param {number} cp_classification_id - ID da classificação do produto
 * @returns {apiResponseType} Resposta da API com detalhes das distribuições vendedor-unidade
 */
export const getSellerToUnityDistributionDetails = (contest_id: string, cp_classification_id: number): apiResponseType =>
  apiAuth.get(`/distributions/seller-balances/seller-unity/show/${contest_id}/details?cp_classification_id=${cp_classification_id}`);

/**
 * Busca detalhes das distribuições entre vendedores por contest_product_classification_id
 * @param {string} contest_id - ID do concurso
 * @param {number} cp_classification_id - ID da classificação do produto
 * @returns {apiResponseType} Resposta da API com detalhes das distribuições entre vendedores
 */
export const getSellerToSellerDistributionDetails = (contest_id: string, cp_classification_id: number): apiResponseType =>
  apiAuth.get(`/distributions/seller-balances/between/show/${contest_id}/details?cp_classification_id=${cp_classification_id}`);

/**
 * Busca detalhes das distribuições entre unidades por contest_product_classification_id
 * @param {string} contest_id - ID do concurso
 * @param {number} cp_classification_id - ID da classificação do produto
 * @returns {apiResponseType} Resposta da API com detalhes das distribuições entre unidades
 */
export const getUnityToUnityDistributionDetails = (contest_id: string, cp_classification_id: number): apiResponseType =>
  apiAuth.get(`/distributions/unity-balances/between/show/${contest_id}/details?cp_classification_id=${cp_classification_id}`);

/**
 * Distribui para vendedores em batch (múltiplos produtos de uma vez)
 * @param data Dados da distribuição em batch
 */
export const storeDistributionSellerBalancesBulk = (data: {
  contest_id: number;
  unity_id: number;
  distributions: Array<{
    contest_product_classification_id: number;
    sellers: Array<{
      id: number;
      quota_quantity: number;
    }>;
  }>;
}): apiResponseType =>
  apiAuth.post("/distributions/seller-balances/store-bulk", data);

export const storeDistributionSellerBalancesBulkWithFiles = (data: FormData): apiResponseType =>
  apiAuth.post("/distributions/seller-balances/store-bulk", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

/**
 * Distribui para unidades em batch (múltiplos produtos de uma vez)
 * @param data Dados da distribuição em batch
 */
export const storeDistributionUnityBalancesBulk = (data: {
  contest_id: number;
  lottery_id: number;
  distributions: Array<{
    contest_product_classification_id: number;
    unities: Array<{
      id: number;
      quota_quantity: number;
    }>;
  }>;
}): apiResponseType =>
  apiAuth.post("/distributions/unity-balances/store-bulk", data);

export const storeDistributionUnityBalancesBulkWithFiles = (data: FormData): apiResponseType =>
  apiAuth.post("/distributions/unity-balances/store-bulk", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

/**
 * Distribui entre vendedores em batch (múltiplos produtos de uma vez)
 * @param data Dados da distribuição em batch
 */
export const distributionBetweenSellersBulk = (data: {
  contest_id: number;
  unity_id: number;
  distributions: Array<{
    contest_product_classification_id: number;
    from_seller_id: number;
    sellers: Array<{
      id: number;
      quota_quantity: number;
    }>;
  }>;
}): apiResponseType =>
  apiAuth.post("/distributions/seller-balances/distribution-between-sellers-bulk", data);

export const distributionBetweenSellersBulkWithFiles = (data: FormData): apiResponseType =>
  apiAuth.post("/distributions/seller-balances/distribution-between-sellers-bulk", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

/**
 * Distribui de vendedor para unidade em batch (múltiplos produtos de uma vez)
 * @param data Dados da distribuição em batch
 */
export const distributionSellerForUnityBulk = (data: {
  contest_id: number;
  lottery_id: number;
  distributions: Array<{
    contest_product_classification_id: number;
    from_seller_id: number;
    unities: Array<{
      id: number;
      quota_quantity: number;
    }>;
  }>;
}): apiResponseType =>
  apiAuth.post("/distributions/seller-balances/distribution-seller-for-unity-bulk", data);

export const distributionSellerForUnityBulkWithFiles = (data: FormData): apiResponseType =>
  apiAuth.post("/distributions/seller-balances/distribution-seller-for-unity-bulk", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

/**
 * Distribui entre unidades em batch (múltiplos produtos de uma vez)
 * @param data Dados da distribuição em batch
 */
export const distributionBetweenUnitiesBulk = (data: {
  contest_id: number;
  lottery_id: number;
  distributions: Array<{
    contest_product_classification_id: number;
    from_unity_id: number;
    unities: Array<{
      id: number;
      quota_quantity: number;
    }>;
  }>;
}): apiResponseType =>
  apiAuth.post("/distributions/unity-balances/distribution-between-unities-bulk", data);

export const distributionBetweenUnitiesBulkWithFiles = (data: FormData): apiResponseType =>
  apiAuth.post("/distributions/unity-balances/distribution-between-unities-bulk", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

/**
 * Export distribution template for a contest
 * @param {string} contest_id - ID do concurso
 * @returns {Promise<Blob>} Arquivo Excel do modelo
 */
export const exportDistributionTemplate = (contest_id: string): Promise<Blob> =>
  apiAuth.get(`/distributions/unity-balances/show/${contest_id}/export-template`, {
    responseType: 'blob',
  }).then(response => response.data);

/**
 * Import distribution from Excel file (preview)
 * @param {string} contest_id - ID do concurso
 * @param {File} file - Arquivo Excel
 * @param {boolean} previewOnly - Se true, retorna apenas preview
 * @returns {apiResponseType} Resposta da API com preview das distribuições
 */
export const importDistributionPreview = (contest_id: string, file: File): apiResponseType => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('preview_only', 'true');
  return apiAuth.post(`/distributions/unity-balances/show/${contest_id}/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * Confirm and process imported distribution
 * @param {string} contest_id - ID do concurso
 * @param {any} distributions - Array de distribuições a serem processadas
 * @param {File[]} files - Arquivos de comprovação
 * @returns {apiResponseType} Resposta da API
 */
export const confirmImportDistribution = (
  contest_id: string,
  distributions: any[],
  files: File[]
): apiResponseType => {
  const formData = new FormData();

  distributions.forEach((dist, index) => {
    formData.append(`distributions[${index}][contest_product_classification_id]`, dist.contest_product_classification_id.toString());
    dist.unities.forEach((unity: any, unityIndex: number) => {
      formData.append(`distributions[${index}][unities][${unityIndex}][id]`, unity.id.toString());
      formData.append(`distributions[${index}][unities][${unityIndex}][quota_quantity]`, unity.quota_quantity.toString());
    });
  });

  files.forEach((file) => {
    formData.append('files[]', file);
  });

  return apiAuth.post(`/distributions/unity-balances/show/${contest_id}/import/confirm`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// ============ SELLER DISTRIBUTION EXPORT/IMPORT ============

/**
 * Export seller distribution template for a contest
 * @param {string} contest_id - ID do concurso
 * @param {number} unity_id - ID da unidade (opcional, filtra vendedores)
 * @returns {Promise<Blob>} Arquivo Excel do modelo
 */
export const exportSellerDistributionTemplate = (contest_id: string, unity_id?: number): Promise<Blob> => {
  const params = unity_id ? `?unity_id=${unity_id}` : '';
  return apiAuth.get(`/distributions/seller-balances/show/${contest_id}/export-template${params}`, {
    responseType: 'blob',
  }).then(response => response.data);
};

/**
 * Import seller distribution from Excel file (preview)
 * @param {string} contest_id - ID do concurso
 * @param {File} file - Arquivo Excel
 * @param {number} unity_id - ID da unidade (opcional)
 * @returns {apiResponseType} Resposta da API com preview das distribuições
 */
export const importSellerDistributionPreview = (contest_id: string, file: File, unity_id?: number): apiResponseType => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('preview_only', 'true');
  if (unity_id) {
    formData.append('unity_id', unity_id.toString());
  }
  return apiAuth.post(`/distributions/seller-balances/show/${contest_id}/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * Confirm and process imported seller distribution
 * @param {string} contest_id - ID do concurso
 * @param {number} unity_id - ID da unidade
 * @param {any} distributions - Array de distribuições a serem processadas
 * @param {File[]} files - Arquivos de comprovação
 * @returns {apiResponseType} Resposta da API
 */
export const confirmImportSellerDistribution = (
  contest_id: string,
  unity_id: number,
  distributions: any[],
  files: File[]
): apiResponseType => {
  const formData = new FormData();
  formData.append('unity_id', unity_id.toString());

  distributions.forEach((dist, index) => {
    formData.append(`distributions[${index}][contest_product_classification_id]`, dist.contest_product_classification_id.toString());
    dist.sellers.forEach((seller: any, sellerIndex: number) => {
      formData.append(`distributions[${index}][sellers][${sellerIndex}][id]`, seller.id.toString());
      formData.append(`distributions[${index}][sellers][${sellerIndex}][quota_quantity]`, seller.quota_quantity.toString());
    });
  });

  files.forEach((file) => {
    formData.append('files[]', file);
  });

  return apiAuth.post(`/distributions/seller-balances/show/${contest_id}/import/confirm`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// ============ BETWEEN UNITIES DISTRIBUTION EXPORT/IMPORT ============

/**
 * Export between unities distribution template for a contest
 * @param {string} contest_id - ID do concurso
 * @returns {Promise<Blob>} Arquivo Excel do modelo
 */
export const exportBetweenUnitiesDistributionTemplate = (contest_id: string): Promise<Blob> => {
  return apiAuth.get(`/distributions/unity-balances/between/show/${contest_id}/export-template`, {
    responseType: 'blob',
  }).then(response => response.data);
};

/**
 * Import between unities distribution from Excel file (preview)
 * @param {string} contest_id - ID do concurso
 * @param {File} file - Arquivo Excel
 * @returns {apiResponseType} Resposta da API com preview das distribuições
 */
export const importBetweenUnitiesDistributionPreview = (contest_id: string, file: File): apiResponseType => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('preview_only', 'true');
  return apiAuth.post(`/distributions/unity-balances/between/show/${contest_id}/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * Confirm and process imported between unities distribution
 * @param {string} contest_id - ID do concurso
 * @param {any} distributions - Array de distribuições a serem processadas
 * @param {File[]} files - Arquivos de comprovação
 * @returns {apiResponseType} Resposta da API
 */
export const confirmImportBetweenUnitiesDistribution = (
  contest_id: string,
  distributions: any[],
  files: File[]
): apiResponseType => {
  const formData = new FormData();

  distributions.forEach((dist, index) => {
    formData.append(`distributions[${index}][contest_product_classification_id]`, dist.contest_product_classification_id.toString());
    dist.unities.forEach((unity: any, unityIndex: number) => {
      formData.append(`distributions[${index}][unities][${unityIndex}][id]`, unity.id.toString());
      formData.append(`distributions[${index}][unities][${unityIndex}][quota_quantity]`, unity.quota_quantity.toString());
    });
  });

  files.forEach((file) => {
    formData.append('files[]', file);
  });

  return apiAuth.post(`/distributions/unity-balances/between/show/${contest_id}/import/confirm`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getDistributionProcessesAll = (params?: {
  page?: number;
  contest_status_id?: number;
  unity_id?: number;
  contest_id?: number;
  lottery_id?: number;
  seller_id?: number;
  start_date?: string;
  end_date?: string;
  updated_from?: string;
  updated_to?: string;
  created_from?: string;
  created_to?: string;
  processed_from?: string;
  processed_to?: string;
  contest_validation_from?: string;
  contest_validation_to?: string;
  contest_name?: string;
  product_name?: string;
  product_classification_id?: number;
  updated_by?: number;
  created_by?: number;
  distribution_type_id?: number;
  status_id?: number;
  from_seller_id?: number;
  from_unity_id?: number;
  contest_product_classification_id?: number;
}): apiResponseType => {
  const queryParams = new URLSearchParams();

  if (params?.page) queryParams.append("page", params.page.toString());
  if (params?.contest_status_id) queryParams.append("contest_status_id", params.contest_status_id.toString());
  if (params?.unity_id) queryParams.append("unity_id", params.unity_id.toString());
  if (params?.contest_id) queryParams.append("contest_id", params.contest_id.toString());
  if (params?.lottery_id) queryParams.append("lottery_id", params.lottery_id.toString());
  if (params?.seller_id) queryParams.append("seller_id", params.seller_id.toString());
  if (params?.start_date) queryParams.append("start_date", params.start_date);
  if (params?.end_date) queryParams.append("end_date", params.end_date);
  if (params?.updated_from) queryParams.append("updated_from", params.updated_from);
  if (params?.updated_to) queryParams.append("updated_to", params.updated_to);
  if (params?.created_from) queryParams.append("created_from", params.created_from);
  if (params?.created_to) queryParams.append("created_to", params.created_to);
  if (params?.processed_from) queryParams.append("processed_from", params.processed_from);
  if (params?.processed_to) queryParams.append("processed_to", params.processed_to);
  if (params?.contest_validation_from) queryParams.append("contest_validation_from", params.contest_validation_from);
  if (params?.contest_validation_to) queryParams.append("contest_validation_to", params.contest_validation_to);
  if (params?.contest_name) queryParams.append("contest_name", params.contest_name);
  if (params?.product_name) queryParams.append("product_name", params.product_name);
  if (params?.product_classification_id) queryParams.append("product_classification_id", params.product_classification_id.toString());
  if (params?.updated_by) queryParams.append("updated_by", params.updated_by.toString());
  if (params?.created_by) queryParams.append("created_by", params.created_by.toString());
  if (params?.distribution_type_id !== undefined) queryParams.append("distribution_type_id", params.distribution_type_id.toString());
  if (params?.status_id !== undefined) queryParams.append("status_id", params.status_id.toString());
  if (params?.from_seller_id) queryParams.append("from_seller_id", params.from_seller_id.toString());
  if (params?.from_unity_id) queryParams.append("from_unity_id", params.from_unity_id.toString());
  if (params?.contest_product_classification_id) queryParams.append("contest_product_classification_id", params.contest_product_classification_id.toString());

  const queryString = queryParams.toString();
  return apiAuth.get(`/distribution-processes/all${queryString ? `?${queryString}` : ""}`);
};

export const bulkProcessDistributions = (data: {
  action: "accept" | "reject";
  uuids: string[];
  reason?: string;
}) =>
  apiAuth.put("/distribution-processes/bulk-process", data) as apiResponseType;
